import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import applicationService from '../../api/applicationService'

const initialState = {
  applications: [],
  selectedApplication: null,
  applicationDetails: null,
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: '',
}

// Fetch all applications
export const fetchApplications = createAsyncThunk(
  'application/fetchAll',
  async (_, thunkAPI) => {
    try {
      return await applicationService.getApplications()
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Fetch application details
export const fetchApplicationDetails = createAsyncThunk(
  'application/fetchDetails',
  async (applicationId, thunkAPI) => {
    try {
      return await applicationService.getApplicationDetails(applicationId)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = false
      state.message = ''
    },
    setSelectedApplication: (state, action) => {
      state.selectedApplication = action.payload
      // Set application details from applications list
      const selectedApp = state.applications.find(app => app.applicationId === action.payload)
      if (selectedApp) {
        state.applicationDetails = selectedApp
      }
    },
    clearApplicationDetails: (state) => {
      state.applicationDetails = null
      state.selectedApplication = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplications.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchApplications.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.applications = action.payload
      })
      .addCase(fetchApplications.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(fetchApplicationDetails.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchApplicationDetails.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.applicationDetails = action.payload
      })
      .addCase(fetchApplicationDetails.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset, setSelectedApplication, clearApplicationDetails } = applicationSlice.actions
export default applicationSlice.reducer
